import React from 'react'
import classnames from 'classnames'
import { LangEum } from '@/constant'
import { logoImg } from '../../constants'
import LayerSelect from '../layerSelect'
import { SelectItemProps } from '../../types'
import styles from './index.module.less'

interface Props<T> {
  logoTopName: string
  logoTopSummary: string
  logoUrl?: string
  lang: LangEum
  options: SelectItemProps<T>[]
  filterValue: T
  onFilterChange: (key: T) => void
}

function Topbar<T>(props: Props<T>) {
  const { logoTopName, logoUrl, logoTopSummary, lang, options, filterValue, onFilterChange } = props

  return (
    <div className={styles['topbar-wrapper']}>
      <div style={{ backgroundImage: `url(${logoUrl})` }} className={styles['topbar-content']}>
        <div
          className={classnames({
            [styles['topbar-header']]: true,
            [styles['topbar-header-en']]: lang === LangEum.en,
          })}
        >
          <img className={styles['topbar-logo-img']} src={logoImg} alt="" />
          {/* <span className={styles['topbar-title']}>{logoTopName}</span> */}
          <span className={styles['topbar-title']}>排行榜</span>
        </div>
        <div className={styles['topbar-describe']}>{logoTopSummary}</div>

        <LayerSelect value={filterValue} onChange={onFilterChange} options={options} />
      </div>
    </div>
  )
}

export default React.memo(Topbar)
